import { render, staticRenderFns } from "./fieldsDisplay.vue?vue&type=template&id=7178a6a2&scoped=true&"
import script from "./fieldsDisplay.vue?vue&type=script&lang=ts&"
export * from "./fieldsDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./fieldsDisplay.vue?vue&type=style&index=0&id=7178a6a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7178a6a2",
  null
  
)

export default component.exports